var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9B9B9",
    d: "M237.627,847.944l-33.253,44.098c-18.092-13.678-35.295-28.649-51.531-44.885 c-45.08-45.08-80.476-97.581-105.205-156.047C22.03,630.565,9.046,566.267,9.046,500c0-66.266,12.984-130.565,38.593-191.11 c24.729-58.466,60.125-110.968,105.205-156.047c16.235-16.235,33.438-31.207,51.53-44.884l33.252,44.097 C132.259,231.708,64.046,358.035,64.046,500S132.26,768.293,237.627,847.944z M935.954,500 c0,141.965-68.214,268.292-173.581,347.944l33.253,44.098c18.093-13.678,35.296-28.649,51.531-44.885 c45.079-45.08,80.476-97.581,105.204-156.047c25.608-60.545,38.593-124.844,38.593-191.11c0-66.266-12.984-130.565-38.593-191.11 c-24.729-58.466-60.125-110.968-105.204-156.047c-16.235-16.235-33.438-31.207-51.53-44.884l-33.253,44.098 C867.74,231.708,935.954,358.035,935.954,500z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinner);
export default __webpack_public_path__ + "static/media/icon-spinner.3b666db23ad166bc9a713deabfbbb6cb.svg";
export { ForwardRef as ReactComponent };